import React, { useEffect, useState } from "react";
import {
  Link,
  NavLink,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { List } from "react-bootstrap-icons";

const backgroundSyle = {
  background: "#00297A",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
};

const chevron = {
  borderStyle: "solid",
  borderWidth: "0.15em 0.15em 0 0",
  content: "",
  display: "inline-block",
  height: "0.55em",
  position: "relative",
  transform: "rotate(-135deg)",
  verticalAlign: "top",
  width: "0.55em",
};

const PortraitView = styled.nav`
  background: #00297a;
  color: #ffffff;
  width: 100%;
  margin: 0px;
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  z-index: 999;
`;

const DropdownMenu = styled.div`
  position: relative;
  display: inline-block;

  .dropdown-content {
    position: absolute;
    background-color: #ffffff;
    min-width: 160px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius: 5px;
    overflow: hidden;
    right: 0;
    ${(props) =>
      !props.useDropdown &&
      css`
        display: none;
      `}
  }

  &:hover .dropdown-content {
    display: block;
  }

  .dropdown-item {
    color: #00197b;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    cursor: pointer;

    &:hover {
      background-color: #f1f1f1;
    }
  }
`;

export const MobileTopBar = ({
  goTo = "",
  titleSpecification = "",
  handleSpecification,
  createJob,
  pluginSubscriptions,
  selectedBallID,
  selectedCustomerID,
  setShowConfirmDeleteArsenal,
}) => {
  const [useDropdown, setUseDropdown] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <PortraitView className="navbar navbar-expand-sm ">
        <div className="container">
          <button
            className="nav-item nav-link btn"
            style={backgroundSyle}
            onClick={handleBack}
          >
            <span style={chevron} />
            <span style={{ marginLeft: "0.75em", textTransform: "capitalize" }}>
              {t(goTo) || ""}
            </span>
          </button>

          {titleSpecification === t("form.label.add_ball") ? (
            <DropdownMenu>
              <button
                className="nav-item nav-link btn"
                style={backgroundSyle}
                onClick={() => {
                  setUseDropdown(!useDropdown);
                }}
              >
                <List style={{ color: "white", fontSize: "30px" }} />
              </button>
              <div className="dropdown-content">
                <div className="dropdown-item" onClick={handleSpecification}>
                  {titleSpecification}
                </div>
                {pluginSubscriptions.indexOf("JOB_BOARD") >= 0 && (
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      createJob({});
                    }}
                  >
                    {t("jobBoard.create")}
                  </div>
                )}
                <div
                  className="dropdown-item"
                  onClick={() => {
                    if (selectedBallID && selectedCustomerID) {
                      navigate(
                        `/print/${selectedCustomerID}/ball/${selectedBallID}`
                      );
                    }
                  }}
                >
                  {t("Print")}
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => {
                    setShowConfirmDeleteArsenal(true);
                  }}
                >
                  {t("form.label.delete_ball")}
                </div>
              </div>
            </DropdownMenu>
          ) : (
            <button
              className="nav-item nav-link btn"
              style={backgroundSyle}
              onClick={handleSpecification}
            >
              {titleSpecification}
            </button>
          )}
        </div>
      </PortraitView>
    </>
  );
};
